import MathUtils from '@/shared/utils/MathUtils';

export default class CServidorTekMonitor {
  servidorId: number = 0;

  /**Código do cliente */
  codigo: number = 0;
  nome: string = '';
  subdominio: string = '';
  utilizaSslInternamente: number = 0;
  servidorObservacao: string | null = null;
  provedor: string = '';
  portaId: number = 0;
  tipo: number = 0;
  recurso: string = '';
  porta: string = '';
  ipExterno: string = '';
  ipInterno: string = '';
  host: string = '';
  versao: string = '';
  compilacao: string = '';
  ultimaConexao: string = '';
  portaObservacao: string | null = null;

  /**
   * Alguns clientes utilizam de links alternativos ao padrão e adequamos
   * o acesso a partir delesCBAse
   */
  linkAlternativo: string = '';

  /**
   * O TekMonitor envia booleano da seguinte forma:
   * - 1 = True
   * - 0 = False
   */
  acessoPeloHorse: boolean = false;

  constructor(pObjeto?: CServidorTekMonitor) {
    if (!pObjeto) {
      return;
    }

    this.servidorId = pObjeto.servidorId;
    this.codigo = pObjeto.codigo;
    this.nome = pObjeto.nome;
    this.subdominio = pObjeto.subdominio;
    this.utilizaSslInternamente = pObjeto.utilizaSslInternamente;
    this.servidorObservacao = pObjeto.servidorObservacao;
    this.provedor = pObjeto.provedor;
    this.portaId = pObjeto.portaId;
    this.tipo = pObjeto.tipo;
    this.recurso = pObjeto.recurso;
    this.porta = pObjeto.porta;
    this.ipExterno = pObjeto.ipExterno;
    this.ipInterno = pObjeto.ipInterno;
    this.host = pObjeto.host;
    this.versao = pObjeto.versao;
    this.compilacao = pObjeto.compilacao;
    this.ultimaConexao = pObjeto.ultimaConexao;
    this.portaObservacao = pObjeto.portaObservacao;
    this.acessoPeloHorse = MathUtils.toBooleano(pObjeto.acessoPeloHorse);

    this.linkAlternativo = pObjeto.linkAlternativo || '';
    if (this.linkAlternativo && this.porta) {
      const lLink = this.linkAlternativo.split(':');

      if (lLink.length > 1) {
        this.linkAlternativo = `https:${lLink[1]}:${this.porta}`;
      }
    }
  }
}
